// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"584":"bf9a81ca","744":"d1bef28c","869":"657918d6","978":"edd29431"}[chunkId] + ".js";
};